import { EmptyPayload } from "@/lib/events/types";
import { Checkpoint } from "./types";
import { Step } from "../steps/v2/step";
import { TourTerminateReason } from "../tourLifecycleManager";

export type TourPlaybackManagerEvents = {
  questionChoiceSelected: { choiceId: string; choiceType: string };
  avatarCaptionClicked: { status: boolean };
  avatarMuteClicked: { status: boolean };
  unsuspended: EmptyPayload;
  checkpointSaved: { checkpoint: Checkpoint };
  checkpointLoaded: EmptyPayload;
  finished: EmptyPayload;
  terminated: { reason?: TourTerminateReason };
  initialized: EmptyPayload;
  started: EmptyPayload;
  suspended: EmptyPayload;
  dismissed: EmptyPayload;
  tourSwitched: { guideId: string };
  stepTransitioned: { step: Step };
  sectionTransitioned: EmptyPayload;
  stepExecuted: EmptyPayload;
  stepDisposed: EmptyPayload;
  flowStarted: EmptyPayload;
  flowFinished: EmptyPayload;
  targetElementNotFound: { reasons: string[] };
  userWanderedOff: EmptyPayload;
  targetElementHighlighted: EmptyPayload;
  targetElementChanged: { currentTarget: string | null; nextTarget: string | null };
  stepFinished: EmptyPayload;
  willStartFlow: { fromTime: number; autoPlay: boolean };
  introStartTourClicked: EmptyPayload;
  introCloseTourClicked: EmptyPayload;
  introPostponeTourClicked: EmptyPayload;
  finishCriteriaMet: EmptyPayload;
  userEngaged: EmptyPayload;
  feedbackClicked: EmptyPayload;
  shortClipFallbackTriggered: EmptyPayload;
  shortClipProceedClicked: EmptyPayload;
};

export type TourPlaybackEventContext = {
  stepId: string;
  stepIndex: number;
  stepOrder: number;
  stepType: string;
  isCheckpoint: boolean;
  totalSteps: number;
  totalSectionSteps: number;
  totalSections: number;
  tourProgress: number;
  flowKey: string;
  currentMediaDuration: number;
  tourPlaybackVersion: string;
  sectionIndex: number;
  time: number;
  startedAt?: number;
  sessionId: string;
};

export const TourPlaybackNamespace = "tourPlayback" as const;
